

import React, { useEffect, useRef } from "react";
import styles from "./Modal2.module.css";

const Modal2 = ({ closeModal }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("keydown", handleEscapeKey);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("keydown", handleEscapeKey);
    };
  }, [closeModal]);

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent} ref={modalRef}>
        <span className={styles.close} onClick={closeModal}>
          X
        </span>
        <img src="/assets/dis.svg" alt="" className={styles.image} />
      </div>
    </div>
  );
};

export default Modal2;
